<div class="labels">
  @if (!loading) {
    <span>{{ 'ASSET_TO_DISPLAY' | translate }}</span>
    <span class="quantity">{{ quantity$ | async }}</span>
    @if (assetQuantity > MAX_ASSET_COUNT) {
      <span>
        <fa-icon icon="exclamation-triangle"></fa-icon>&nbsp;
        {{ 'ASSETS_ABOVE_LIMIT' | translate:{quantity: MAX_ASSET_COUNT} }}
      </span>
    } @else {
      <span>
        <fa-icon icon="check"></fa-icon>&nbsp;
        {{ 'ASSETS_UNDER_LIMIT' | translate:{quantity: MAX_ASSET_COUNT} }}
      </span>
    }
  } @else {
    <span>{{ 'LOADING_DATA' | translate }}</span>
    <mat-progress-spinner color="primary"
      mode="indeterminate"
    diameter="32"></mat-progress-spinner>
  }
</div>
